/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LayerConfigurations } from "../models/http/what-if/layer/layer-info.model";
import { WhatIfLayerHttpService } from "./http/what-if-layer-http.service";

@Injectable({
	providedIn: "root"
})
export class WhatIfLayerService {
	constructor(private _whatIfLayerHttpService: WhatIfLayerHttpService) {}

	/**
	 * Edits all scenario layers for a given application and scenario.
	 *
	 * @param appId - The ID of the application.
	 * @param scenarioId - The ID of the scenario.
	 * @param tenantId - The ID of the tenant.
	 * @param layerConfigs - The configuration of the layers to be edited.
	 * @returns An Observable that emits an object containing a message.
	 */
	public editAllScenarioLayers(
		appId: string,
		scenarioId: number,
		tenantId: string,
		layerConfigs: LayerConfigurations
	): Observable<string> {
		return this._whatIfLayerHttpService.editAllScenarioLayers(
			appId,
			scenarioId,
			tenantId,
			layerConfigs
		);
	}

	/**
	 * Edits a scenario layer with the given configurations.
	 *
	 * @param appId - The application ID.
	 * @param scenarioId - The scenario ID.
	 * @param layerId - The layer ID.
	 * @param tenantId - The tenant ID.
	 * @param layerConfigs - The configurations for the layer.
	 * @returns An Observable that emits an object containing a message.
	 */
	public editScenariolayer(
		appId: string,
		scenarioId: number,
		layerId: string,
		tenantId: string,
		layerConfigs: LayerConfigurations
	): Observable<string> {
		return this._whatIfLayerHttpService.editScenariolayer(
			appId,
			scenarioId,
			layerId,
			tenantId,
			layerConfigs
		);
	}
}
